const setupTags = (posts) => {
  const tagCounts = posts.reduce((accumulator, currentValue) => {
    currentValue.meta.tags.forEach((tag) => {
      if (accumulator[tag]) {
        accumulator[tag]++;
      } else {
        accumulator[tag] = 1;
      }
    });

    return accumulator;
  }, {});

  return Object.entries(tagCounts).sort();
};

const getRandomPosts = (posts, count) => {
  const shuffled = posts.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

export { setupTags, getRandomPosts };

export { customSlugify as slugify } from './customSlugify';

export * from './dateUtils';
export * from './getPaginationRange';
export * from './stringUtils';
